import { IEditBehavior } from "./IEditBehavior";

export class EditBehavior {
  constructor(public isVisible: boolean = true) {}

  clone(): EditBehavior {
    return new EditBehavior(this.isVisible);
  }

  static from(source: IEditBehavior): EditBehavior {
    return new EditBehavior(source.isVisible);
  }

  static to(source: EditBehavior): IEditBehavior {
    return {
      isVisible: source.isVisible,
    };
  }
}
